import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as t from "react";
import { env as f } from '../utils/env.js';
function s() {
  var r = typeof document == "undefined";
  return "useSyncExternalStore" in t ? function (o) {
    return o.useSyncExternalStore;
  }(t)(function () {
    return function () {};
  }, function () {
    return !1;
  }, function () {
    return !r;
  }) : !1;
}
function l() {
  var r = s(),
    _t$useState = t.useState(f.isHandoffComplete),
    _t$useState2 = _slicedToArray(_t$useState, 2),
    e = _t$useState2[0],
    n = _t$useState2[1];
  return e && f.isHandoffComplete === !1 && n(!1), t.useEffect(function () {
    e !== !0 && n(!0);
  }, [e]), t.useEffect(function () {
    return f.handoff();
  }, []), r ? !1 : e;
}
export { l as useServerHandoffComplete };